import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  SvgIdentificate,
  SvgSalir,
  SvgEditarUsuario,
  SvgFactura,
  SvgCorreo,
  SvgQuienesSomos,
  SvgSuscripcion,
  SvgGanancias,
} from "@/icons";
import TooltipLogBlock from "@/tooltip/TooltipLogBlock";
import { ButtonIconos } from "../../ui";
import { jwtDecode } from "jwt-decode";
import { DecodedToken } from "@/types";
import EligeEmpresa from "../logBlock/EligeEmpresa";

// Componente del menú horizontal superior con botones según rol
const HorizontalMenu: React.FC = () => {
  const [role, setRole] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decodedToken = jwtDecode<DecodedToken>(token);
        setRole((decodedToken.rol || "").trim().toLowerCase());
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  const handleLogout = () => {
    if (window.confirm("¿Estás seguro de que deseas cerrar sesión?")) {
      localStorage.removeItem("token");
      setRole(null);
      navigate("/");
    }
  };

  const isAdmin = ["admin", "superadmin"].includes(role || "");
  const isProfesional = role === "profesional";
  const isAfiliado = role === "afiliado";
  const isUsuario = role === "usuario";
  const canSeeSuscripcion = isProfesional || isUsuario || isAdmin;

  return (
    <div className="fixed top-1.5 right-2 z-50 flex gap-2 pointer-events-auto bg-white p-1 rounded mr-3">
      {!role ? (
        <>
          <Link to="/sign">
            <TooltipLogBlock label="Entrar">
              <ButtonIconos>
                <SvgIdentificate />
              </ButtonIconos>
            </TooltipLogBlock>
          </Link>

          <Link to="/suscribirse">
            <TooltipLogBlock label="Suscripción profesional">
              <ButtonIconos>
                <SvgSuscripcion />
              </ButtonIconos>
            </TooltipLogBlock>
          </Link>

          <Link to="/contacto">
            <TooltipLogBlock label="Soporte. Att cliente">
              <ButtonIconos>
                <SvgCorreo />
              </ButtonIconos>
            </TooltipLogBlock>
          </Link>

          <Link to="/sobreNosotros">
            <TooltipLogBlock label="Sobre Nosotros">
              <ButtonIconos>
                <SvgQuienesSomos />
              </ButtonIconos>
            </TooltipLogBlock>
          </Link>
        </>
      ) : (
        <>
          {!isAdmin && (
            <>
              {/* 🔵 PROFESIONAL */}
              {isProfesional && (
                <>
                  <Link to="/contratosFacturas">
                    <TooltipLogBlock label="Contratos y Facturas">
                      <ButtonIconos>
                        <SvgFactura />
                      </ButtonIconos>
                    </TooltipLogBlock>
                  </Link>

                  <EligeEmpresa />
                </>
              )}

              {/* 🟢 AFILIADO + PROFESIONAL */}
              {(isProfesional || isAfiliado || isUsuario) && (
                <Link to="/editaUsuario">
                  <TooltipLogBlock label="Editar usuario">
                    <ButtonIconos>
                      <SvgEditarUsuario />
                    </ButtonIconos>
                  </TooltipLogBlock>
                </Link>
              )}

              {/* 🟣 SOLO AFILIADO */}
              {isAfiliado && (
                <Link to="/panelAfiliado">
                  <TooltipLogBlock label="Monetización">
                    <ButtonIconos>
                      <SvgGanancias />
                    </ButtonIconos>
                  </TooltipLogBlock>
                </Link>
              )}

              {/* 🔵 SOLO PROFESIONAL */}
              {canSeeSuscripcion && (
                <Link to="/suscribirse">
                  <TooltipLogBlock label="Suscripción profesional">
                    <ButtonIconos>
                      <SvgSuscripcion />
                    </ButtonIconos>
                  </TooltipLogBlock>
                </Link>
              )}
            </>
          )}

          {/* 🔴 SIEMPRE */}
          <TooltipLogBlock label="Salir">
            <ButtonIconos onClick={handleLogout}>
              <SvgSalir className="text-red-600" />
            </ButtonIconos>
          </TooltipLogBlock>
        </>
      )}
    </div>
  );
};

export default HorizontalMenu;
